import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { makeSelectDaysFilterContent } from '../selectors';
import { setDaysFilterDataArray, setDaysFilterId } from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import initialStateConstants from '../initialStateConstants';

export const DaysPreFilter = ({ daysItems, onSetDaysFilterId, onSetDaysFilterDataArray }) => {
  const appHistory = useHistory();
  const { search } = useLocation();
  const [queryParams, setQueryParams] = useState(queryString.parse(search)?.days ?? '');

  /**
   * @implements useEffect()
   *
   * Checks if filter should be run once (new) filterable items
   * become available.
   */
  useEffect(() => {
    if (queryParams.length > 0) {
      preFilter(queryParams);
    }
  }, [daysItems]);

  /**
   * @implements useEffect()
   *
   * Checks if a query parameter for this filter has changed and
   * kicks-off updates.
   */
  useEffect(() => {
    let newQueryString = queryString.parse(search)?.days ?? '';
    if (newQueryString === queryParams) {
      return null;
    }
    if (appHistory.action === 'POP') {
      preFilter(newQueryString);
    }
    setQueryParams(newQueryString);
  }, [search]);

  const preFilter = (newQueryString) => {
    if (daysItems.length === 0) {
      return null;
    }
    let filterItems = [];
    if (newQueryString.length > 0) {
      filterItems = newQueryString.split('_');
    }
    if (filterItems?.length > 0) {
      onSetDaysFilterId(filterItems);
      const dayStrings = filterItems.map((currentItem) => {
        const result = daysItems.find((item) => Object.keys(item)[0] === currentItem);
        return result[Object.keys(result)].name;
      });
      onSetDaysFilterDataArray(dayStrings);
    } else {
      resetFilter();
    }
  };

  const resetFilter = () => {
    onSetDaysFilterId(initialStateConstants.daysFilterId);
    onSetDaysFilterDataArray(initialStateConstants.daysFilterDataArray);
  };

  return <></>;
};

DaysPreFilter.propTypes = {
  daysItems: PropTypes.array,
  onSetDaysFilterId: PropTypes.func,
  onSetDaysFilterDataArray: PropTypes.func,
};

DaysPreFilter.defaultProps = {
  daysItems: [],
  onSetDaysFilterId: () => {},
  onSetDaysFilterDataArray: () => {},
};

const mapStateToProps = createStructuredSelector({
  daysItems: makeSelectDaysFilterContent(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetDaysFilterId: (value) => dispatch(setDaysFilterId(value)),
    onSetDaysFilterDataArray: (value) => dispatch(setDaysFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(DaysPreFilter);
